module.exports = __webpack_public_path__ + "img/TESLA-Model-3.0529ee92.jpeg";